import moment from 'moment/min/moment-with-locales';
export class MomentLocaleUtil {

  public static getTranslatedMonthYear(year: number, month: number) {
    let language = localStorage.getItem('language');

    if (language !== 'de' && language !== 'zh') {
      language = 'en';
    } else if (language === 'zh') {
      language = 'zh-cn';
    }

    return moment().locale(language).year(year).month(month).format('MMMM YYYY');
  }

  public static getTranslatedMoment(date: moment.Moment) {
    if (!date) { return null; }

    let language = localStorage.getItem('language');

    if (language !== 'de' && language !== 'zh') {
      language = 'en';
    } else if (language === 'zh') {
      language = 'zh-cn';
    }

    return date.locale(language).format('MMMM YYYY');
  }
}
